import axios, { AxiosError } from "axios";
import { ApiError } from "src/models/Api";
import { handleGetAccessToken } from "./auth";

// Configuração da base URL da API
//const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const BASE_URL = "https://pcp-desirius.com.br/api";
//const BASE_URL = "http://127.0.0.1:8000/api";

// API key desabilitada para teste
const generateFrontendApiKey = async (): Promise<string> => {
    return 'disabled';
};

export const useApi = async <TypeDataResponse>(
    endpoint: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
    data?: object,
    withAuth: boolean = true
): Promise<{
    data?: TypeDataResponse,
    detail: string
}> => {
    const access_token = handleGetAccessToken();

    let headers = {};
    
    if (withAuth && access_token) {
        headers['Authorization'] = `Bearer ${access_token}`;
    }

    try {
        const request = await axios(`${BASE_URL}/${endpoint}`, {
            method,
            data: method != 'GET' && data,
            params: method == 'GET' && data,
            headers
        })

        return {
            data: request.data,
            detail: ''
        }
    } catch (e) {
        const error = e as AxiosError<{
            detail?: string,
            message?: string,
            success?: boolean
        }>;

        // Verifica primeiro se existe message, depois detail, e por último error.message
        const errorMessage = error.response?.data?.message ||
                            error.response?.data?.detail ||
                            error.message;

        return {
            data: null,
            detail: errorMessage
        }
    }
}
